// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__ekagV","large":"styles_large__1vxbm"};